import React, { useState, useEffect } from "react";

const NavbarFooterWrapper = ({ children }) => {
  const [menuOpen, setMenuOpen] = useState(false);
  
  // Close menu when clicking outside or on a link
  useEffect(() => {
    const closeMenu = () => setMenuOpen(false);
    
    // Add event listener when menu is open
    if (menuOpen) {
      document.addEventListener('click', closeMenu);
    }
    
    // Clean up
    return () => {
      document.removeEventListener('click', closeMenu);
    };
  }, [menuOpen]);
  
  // Prevent menu closure when clicking the menu itself
  const handleMenuClick = (e) => {
    e.stopPropagation();
  };
  
  // Toggle menu open/closed
  const toggleMenu = (e) => {
    e.stopPropagation();
    setMenuOpen(!menuOpen);
  };

  return (
    <div className="app">
      <header className="navbar">
        <div className="navbar-left">
          <img src="/logo-full.png" alt="Agentic Farms" className="logo" />
        </div>
        
        {/* Hamburger Icon for Mobile */}
        <div className="mobile-menu-toggle" onClick={toggleMenu}>
          <div className={`hamburger ${menuOpen ? 'open' : ''}`}>
            <span></span>
            <span></span>
            <span></span>
          </div>
        </div>
        
        {/* Navigation Links */}
        <nav className={`navbar-right ${menuOpen ? 'open' : ''}`} onClick={handleMenuClick}>
          <a href="/#calendar-booking" className="primary-btn" onClick={() => setMenuOpen(false)}>Get Started</a>
        </nav>
      </header>

      {children}

      <footer style={{ background: '#FBEAD6', padding: '2rem 0 1.5rem 0', textAlign: 'center' }}>
        <a href="https://www.instagram.com/agenticfarms/?igsh=cXFldW9xbHdicjlu#" target="_blank" rel="noopener noreferrer" style={{ color: '#3B2314', textDecoration: 'none', fontWeight: 600, margin: '0 1.5rem' }}>Instagram</a>
        <a href="https://www.linkedin.com/company/106753012" target="_blank" rel="noopener noreferrer" style={{ color: '#3B2314', textDecoration: 'none', fontWeight: 600, margin: '0 1.5rem' }}>LinkedIn</a>
      </footer>
    </div>
  );
};

export default NavbarFooterWrapper;